import BaseModel from '@/libs/base/dataModel/BaseModel';

export class CommunityAnalysisListModel extends BaseModel {
  constructor () {
    super();
    this.id = '';
    // 省
    this.provinceName = '';
    // 市
    this.cityName = '';
    // 区县
    this.districtName = '';
    // 小区名称
    this.communityName = '';
    // 物业SAP项目编码
    this.pcSapCode = '';
    // 充电桩总数
    this.enabledDeviceNum = '';
    // 地面安装雨棚设备数量
    this.groundCanopyDeviceNum = '';
    // 地面未安装雨棚设备数量
    this.groundNotCanopyDeviceNum = '';
    // 地下设备数量
    this.undergroundDeviceNum = '';
    // 架空层设备数量
    this.elevatedDeviceNum = '';
    // 端口使用率
    this.portUseRate = '';
    // 启用状态的端口数量
    this.enabledPortNum = '';
    // 端口总数
    this.portNum = '';
    // 有效充电订单数
    this.availableOrderNum = '';
    // 有效充电订单消费金额
    this.availableOrderAmount = '';
    // 用户数量
    this.customerNum = '';
    // 平均充电次数
    this.customerChargeAvgNum = '';
    // 客单价
    this.customerAvgAmount = '';
    // 人工退款订单数
    this.manualRefundOrderNum = '';
    // 人工退款订单金额
    this.manualRefundOrderAmount = '';
    // 前端专用 ==========>
    // 是否已选中
    this._checked = false;
    // 勾选的主键
    this._checkId = '';
    // 前端专用 ==========>
  }

  initData (resData) {
    super.initData(resData);
    this._checkId = this.id;
    this.portUseRate = Number((resData.portUseRate * 100).toFixed(2));
    return this;
  }

  static createFakeDataList (len = 30) {
    const list = [];
    for (let i = 0; i < len; i++) {
      const dic = {
        provinceName: BaseModel.getFakeTitle(3),
        cityName: BaseModel.getFakeTitle(3),
        districtName: BaseModel.getFakeTitle(3),
        communityName: BaseModel.getFakeTitle(8),
        pcSapCode: 'GYUGIOJOVHO' + BaseModel.getFakeNumber().toFixed(0),
        enabledDeviceNum: BaseModel.getFakeNumber().toFixed(0),
        groundCanopyDeviceNum: BaseModel.getFakeNumber().toFixed(0),
        groundNotCanopyDeviceNum: BaseModel.getFakeNumber().toFixed(0),
        undergroundDeviceNum: BaseModel.getFakeNumber().toFixed(0),
        elevatedDeviceNum: BaseModel.getFakeNumber().toFixed(0),
        portUseRate: i % 3,
        enabledPortNum: BaseModel.getFakeNumber().toFixed(0),
        portNum: BaseModel.getFakeNumber().toFixed(0),
        availableOrderNum: BaseModel.getFakeNumber().toFixed(0),
        availableOrderAmount: BaseModel.getFakeNumber(),
        customerNum: BaseModel.getFakeNumber().toFixed(0),
        customerChargeAvgNum: BaseModel.getFakeNumber().toFixed(0),
        customerAvgAmount: BaseModel.getFakeNumber(5),
        manualRefundOrderNum: BaseModel.getFakeNumber().toFixed(0),
        manualRefundOrderAmount: BaseModel.getFakeNumber()
      };
      list.push(dic);
    }
    return list;
  }
}
